// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"683":"95979751","1391":"95979751","1407":"9ea1b60b","4421":"6c2c3daa","5907":"5d570733","8236":"104e5aef","9925":"ba2ff9ec"}[chunkId] + ".chunk.css";
};